module.exports = __webpack_public_path__ + "static/media/dance.b3ded326.svg";